export const DHIGWM = {
  title: {
    value: 'DHI GWM 2024',
  },
  paragraph: {
    value: `The DHI global wave model dataset (GWM) is generated by DHI's 3rd generation MIKE 21 Spectral Wave Model based on the high accuracy global ERA5 wind dataset from ECMWF. The ERA5 wind dataset is an exceptionally good basis for global (and regional) wave modelling, and Wind Speeds > 12 m/s have been corrected for a better representation of wave modelling. The model includes island parameterisation and data assimilation of satellite altimeter data. The results have been calibrated and validated against a number of offshore buoys and satellite data.`,
  },
  table: {
    value: {
      header: ['General', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          General: 'Title',
          Model: 'Global, Waves, MIKE 21 Spectral Wave Model (SW), ERA5, DHI (DHI GWM 2024)',
        },
        {
          General: 'Geographical Coverage',
          Model: 'Global',
        },
        {
          General: 'Category',
          Model: 'Waves',
        },
        {
          General: 'Source Name',
          Model: 'MIKE 21 Spectral Wave Model (SW)',
        },
        {
          General: 'Publisher',
          Model: 'DHI',
        },
        {
          General: 'Cost (ex. VAT)',
          Model: 'Requires MIKE Data Link Premium Subscription (TBC)',
        },
        {
          General: 'Typical Applications',
          Model: 'Metocean studies, Hydrodynamic, Offshore and Marine projects',
        },
        {
          General: 'Usage Limitations',
          Model: `Waves during Tropical cyclones (hurricanes/typhoons) may not be well represented (resolved). Data extracted in minor enclosed areas and near-shore may be affected by the spatial resolution.`,
        },
      ],
    },
  },
  table1: {
    value: {
      header: ['Coverage', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          Coverage: 'Geographical Reference',
          Model: 'EPSG:4326 (WGS84)',
        },
        {
          Coverage: 'Geographical Range',
          Model: `Longitude: 180°W – 180°E
          Latitude: 79°S – 81°N`,
        },
        {
          Coverage: 'Geographical Resolution',
          Model: `Mainly 15 - 50km (flexible mesh with varying cell size)`,
        },
        {
          Coverage: 'Vertical Reference',
          Model: 'Sea Surface',
        },
        {
          Coverage: 'Temporal Reference',
          Model: 'UTC',
        },
        {
          Coverage: 'Temporal Range',
          Model: '1979-2023',
        },
        {
          Coverage: 'Temporal Resolution',
          Model: '1 hour',
        },
      ],
    },
  },
  table2: {
    value: {
      header: ['Variables', 'Model'],
      hiddenHeaders: ['Model'],
      rows: [
        {
          Variables: 'Name (Unit)',
          Model: `Significant Wave Height (Hm0), [m]
            Peak Wave Period (Tp), [s]
            Mean Wave Period (T01), [s]
            Zero-crossing Wave Period (T02), [s]
            Peak Wave Direction (PWD), [Deg. N. (coming from)]
            Mean Wave Direction (MWD), [Deg. N. (coming from)]
            Directional Standard Deviation (DSD), [degree]`,
        },
        {
          Variables: 'Definitions',
          Model: 'Total sea state, wind-sea and swell (wave-age)',
        },
      ],
    },
  },
};
